/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchCompliance {
    getFixupPrototypeFunction() { return PatchCompliance.fixupPrototype; }

    static newInstance(model: Partial<PatchCompliance>): PatchCompliance {
        let obj = Object.assign(new PatchCompliance(), model);
        PatchCompliance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchCompliance>): PatchCompliance {
        if (!model) return null;
        return PatchCompliance.newInstance(<PatchCompliance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchCompliance) {
        if (!obj) return;

        models.PatchCompliance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchCompliance): boolean {
        Object.setPrototypeOf(obj, PatchCompliance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Indicates if patch compliance is supported
     */
    enabled: boolean;

    /**
     * True if compliant with patches, False if not
     */
    status: boolean;

}
